import React, { useState , useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom'
import {
	loadingToggleAction, loginAction,
} from '../../store/actions/AuthActions';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendToReCapatcha } from '../../services/AuthService';

import logo from '../../images/logo-full.png'

function Login(props) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [recaptchaToken, setRecaptchaToken] = useState(null);

	const getURLParameter = (name) => {
		const params = new URLSearchParams(window.location.search);
		return params.get(name);
	};

	useEffect(() => {
		const userDetails = localStorage.getItem('userDetails');
		const requestType = getURLParameter('r');
		const requestId = getURLParameter('id');

		if (userDetails) {
			// Se tiver parâmetros de redirecionamento, redireciona para a página específica
			if (requestType === 'pedido' && requestId) {
				navigate(`/pedido?p=${requestId}`);
			} else {
				navigate('/');
			}
		}
	}, [navigate]);

	const onRecaptchaChange = (token) => {
		setRecaptchaToken(token);
	};

	function onLogin(e) {
		e.preventDefault();
		
		const username = getURLParameter('u');
		const password = getURLParameter('s');
		const requestType = getURLParameter('r');
		const requestId = getURLParameter('id');

		if (!username || !password) {
			alert('Parâmetros de login inválidos na URL');
			return;
		}

		if (!recaptchaToken) {
			alert('É necessário realizar o teste do reCAPTCHA para logar.');
			return;
		}

		dispatch(loadingToggleAction(true));
		dispatch(loginAction(username, password, recaptchaToken));

		// Redireciona com base nos parâmetros
		if (requestType === 'pedido' && requestId) {
			navigate(`/pedido?p=${requestId}`);
		} else {
			navigate('/');
		}
	}

	return (
		<div className="container-fluid mt-0"
			style={{
				backgroundImage: "linear-gradient(to right top, #165cc6, #1078d8, #2993e7, #4aaef4, #6dc8ff)",
				height: '100vh',
				display: 'flex', alignItems: 'center', justifyContent: 'center'
			}}>
			<div className="row align-items-center justify-contain-center bg-login" style={{ width: '100%' }}>
				<div className="col-xl-12">
					<div id="login-ctn" className="card border-0" style={{ width: '100%' }}>
						<div className="card-body login-bx">
							<div className="row">
								<div style={{ margin: '0 auto', width: '100%' }}>
									<div className="sign-in-your">
										<div className="text-center mb-3">
											<img src={logo} className="mb-3" alt="" style={{ maxWidth: 180 }} />
											<br />
											<h4 className="fs-20 font-w800" style={{ color: 'white', textShadow: '#1463ca 2px 2px 2px' }}>Entrar na Conta</h4>
										</div>
										{props.errorMessage && (
											<div className='bg-red-300 text-red-900 border border-red-900 p-1 my-2'>
												{props.errorMessage}
											</div>
										)}
										{props.successMessage && (
											<div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
												{props.successMessage}
											</div>
										)}
										<form onSubmit={onLogin}>
											<div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
												<ReCAPTCHA
													sitekey={"6LdLwaQqAAAAAL4Ktttukdp8qXT5pcHHd4PFbtOS"}
													onChange={onRecaptchaChange}
												/> 
											</div>
											<div className="text-center">
												<button type="submit" className="btn btn-light btn-block" style={{ maxWidth: '200px', margin: '0 auto' }}>ENTRAR</button>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const mapStateToProps = (state) => {
	return {
		errorMessage: state.auth.errorMessage,
		successMessage: state.auth.successMessage,
		showLoading: state.auth.showLoading,
	};
};
export default connect(mapStateToProps)(Login);